export const classes = {
  root: {
    display: 'flex',
    fontSize: 29,
    fontWeight: 500,
  },
};
